// extracted by mini-css-extract-plugin
export default {"checkIcon":"XRF7D"};